<template>
  <td class="p-3 d-flex justify-content-end align-items-center">
    <template v-for="(action, index) in actions">
      <CxButton variant="table-action" v-if="index < 3" :key="action.icon" :icon="action.icon" @click="action.action" />
    </template>
    <!-- Create dropdown for more than 3 actions -->
  </td>
</template>

<script setup lang="ts">
import { CxButton } from "@/designSystem";
import type { TableAction } from "@/designSystem/Table/constant";

defineProps<{
  actions: TableAction[];
}>();
</script>

<style scoped lang="scss">
@import "@/designSystem/Table/cx-table.scss";
</style>
